import ArkLoader from '@src/js/common/ark-extensions';
import { extensionServiceAdapter } from '@tencent/docs-titlebar-service';
import {
    DocInfoExtendEventsKeys,
} from '@src/slide/application/no-edit/service/doc-extend-service/doc-extend-service-events.interface';
import TocEditPcWorkbenchLoader from '@framework/workbench/loader/toc/toc-edit-pc-loader';
import { IWorkbench, EventEmitter, MiddlewareService } from '@tencent/workbench';
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';

const VIP_INFO = 'vipInfo';

/**
 * toc完整的loader实现
 */
export default class TocPcWorkbenchLoader extends TocEditPcWorkbenchLoader {
    public constructor(
        workbench: IWorkbench,
        eventEmitter: EventEmitter,
        middlewareService: MiddlewareService,
    ) {
        super(workbench, eventEmitter, middlewareService);
    }

    public $onReady() {
        super.$onReady();
        this.loadVipAgain();
    }

    /**
     * 初始化组件titlebar需要的extensionService
     */
    protected initExtensionServiceAdapter() {
        super.initExtensionServiceAdapter();
        const {
            accountApplication,
        } = ArkLoader.extensionService.dependentServiceCombinder;
        this.loadVipInfo();
        extensionServiceAdapter.updateApplicationService({
            accountApplication,
        });
    }

    private loadVipAgain() {
        const eventOff = this.getAppService().viewableServiceLayer.extensionService.getDocInfo()?.addEventListener(
            DocInfoExtendEventsKeys.USER_INFO_READY_EVENT,
            () => {
                eventOff?.();
                // authenticate回来之后vip信息可能被改坏，再重新拉一下(不知道这个方法干嘛的，但是肯定会拉vip信息并更新到accountApplication上)
                this.loadVipInfo();
            },
        );
    }

    // 封装一层确保免登录场景不触发接口请求
    private loadVipInfo() {
        if (shouldDisableNetwork()) {
            return;
        }
        ArkLoader.extensionService.dependentServiceCombinder?.accountApplication.mutate(VIP_INFO);
    }
}
